import { useEffect, useState } from "react";
import { getDecryptedData } from "../../config/crypto";
import { REACT_APP_API_PORT } from "../../Api";
import "react-circular-progressbar/dist/styles.css";
import axios from "axios";
import Loader from "../Loader";
import { useNavigate } from "react-router";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

const CoursePayments = () => {
    const navigate = useNavigate();
    const [apiIsLoading, setApiIsLoading] = useState(false);
    const [data, setData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const limit = 5; // Number of records per page

    useEffect(() => {
        const getData = async () => {
            try {
                setApiIsLoading(true);
                const token = getDecryptedData("token");
                const res = await axios.get(`${REACT_APP_API_PORT}user/course/order/course-payment-history-list?page=${currentPage}&limit=${limit}`, {
                    headers: {
                        "Content-Type": "application/json",
                        "x-access-token": token,
                    },
                });
                setApiIsLoading(false);
                if (res.data.status) {
                    setData(res.data.data);
                    setTotalPages(res.data.pagination.totalPages);
                }
            } catch (err) {
                setApiIsLoading(false);
                console.log(err);
            }
        };
        getData();
    }, [currentPage]);

    // Function to handle page change
    const goToPage = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    return (
        <div className="container py-4">
            <Loader isLoading={apiIsLoading} />
            {/* <h2 className="text-xl font-semibold mb-4 text-white">Payment History</h2> */}

            <div className="overflow-x-auto">
                <table className="w-full min-w-max  border-white/10  shadow-md border-t-white/10">
                    <thead className="bg-background-back2 text-white">
                        <tr className="text-left border-t-0 border-white/10">
                            <th className="py-3 px-4 border-b border-white/0">Course Name</th>
                            <th className="py-3 px-4 border-b border-white/0">Amount</th>
                            <th className="py-3 px-4 border-b border-white/0">Status</th>
                            <th className="py-3 px-4 border-b border-white/0">Payment Date</th>
                        </tr>
                    </thead>
                    <tbody className="border border-l-white/10 border-white/10">
                        {data.length > 0 ? (
                            data.map((payment, index) => (
                                <tr key={index} className="border-b hover:bg-gray-50 bg-background-back2 text-white">
                                    <td className="py-3 px-4">{payment?.course_order_id?.course_name}</td>
                                    <td className="py-3 px-4">₹{payment.amount/100}</td>
                                    <td className="py-3 px-4">
                                        <span className={`px-2 py-1 rounded text-white text-sm ${
                                            payment.status === "captured" ? "bg-green-500" : "bg-red-500"
                                        }`}>
                                            {(payment.status === "captured") ? "Success" : payment.status  }
                                        </span>
                                    </td>
                                    <td className="py-3 px-4">{new Date(payment.createdAt).toLocaleDateString()}</td>
                                </tr>
                            ))
                        ) : (
                            <tr className="bg-background-back1 border-t-0">
                                <td colSpan="4" className="text-center py-4 text-gray-500 border-t-0">No payment history found</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>

            {/* Pagination Controls */}
            {totalPages > 1 && (
                <div className="flex justify-center items-center gap-3 mt-4">
                    <button
                        className={`p-2 rounded-md bg-blue-600 text-white border ${currentPage === 1 ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => goToPage(currentPage - 1)}
                        disabled={currentPage === 1}
                    >
                        <FaChevronLeft />
                    </button>

                    <span className="text-gray-700 font-medium">
                        Page {currentPage} of {totalPages}
                    </span>

                    <button
                        className={`p-2 rounded-md  bg-blue-600 text-white border ${currentPage === totalPages ? "opacity-50 cursor-not-allowed" : "hover:bg-gray-200"}`}
                        onClick={() => goToPage(currentPage + 1)}
                        disabled={currentPage === totalPages}
                    >
                        <FaChevronRight />
                    </button>
                </div>
            )}
        </div>
    );
};

export default CoursePayments;
